export const tableHeader = {
  'Reg. no.': 'regNo',
  'Milage': 'milage',
  'Fuel level': 'fuelLevel',
  'Floor area': 'floorArea',
  'Weight': 'weight',
  'GPS s.no.': 'serialNo',
  'Status': 'status',
};
